"use client";

// 컴포넌트 및 유틸리티 export
export {
  default as LumirEditor,
  ContentUtils,
  EditorConfig,
} from "./components/LumirEditor";
export { cn } from "./utils/cn";
export { createS3Uploader } from "./utils/s3-uploader";
export { HtmlPreviewBlock, schema as HtmlPreviewSchema } from "./blocks/HtmlPreview";
export { LinkPreviewBlock, fetchLinkMetadata, clearMetadataCache } from "./blocks/LinkPreview";
export type { LinkMetadata } from "./blocks/LinkPreview";

// FloatingMenu 및 관련 컴포넌트 export
export { FloatingMenu } from "./components/FloatingMenu";

// 글자 크기(fontSize) 관련 export
// - FontSize: 커스텀 스타일 스펙, FONT_SIZE_PRESETS: 툴바 프리셋
// - liftFontSize/lowerFontSize: 직렬화 호환 레이어(형제 키 ↔ styles.fontSize).
//   BlockNote 외부 렌더러에서 저장 JSON을 재수화할 때 liftFontSize를 사용한다.
export {
  FontSize,
  FONT_SIZE_PRESETS,
  FONT_SIZE_MIN,
  FONT_SIZE_MAX,
  FONT_SIZE_DEFAULT_PX,
  FONT_SIZE_STEP,
  parseFontSizePx,
  clampFontSizePx,
  toFontSizeValue,
} from "./styles/FontSizeStyle";
export type { FontSizePreset } from "./styles/FontSizeStyle";
export { FontSizeButton } from "./components/FontSizeButton";
export {
  liftFontSize,
  lowerFontSize,
} from "./utils/font-size-serialization";
export type { SerializedStyledText } from "./utils/font-size-serialization";

// 에러 클래스 export
export { LumirEditorError } from "./errors/LumirEditorError";
export type { LumirErrorCode, LumirErrorDetails } from "./errors/LumirEditorError";

// 색상 상수 export
export {
  TEXT_COLORS,
  BACKGROUND_COLORS,
  getHexFromColorValue,
} from "./constants/colors";
export type { ColorItem } from "./constants/colors";

// 타입 export (별도 파일에서 관리)
export type {
  LumirEditorProps,
  EditorType,
  DefaultPartialBlock,
  DefaultBlockSchema,
  DefaultInlineContentSchema,
  DefaultStyleSchema,
  PartialBlock,
  BlockNoteEditor,
} from "./types";
export type { S3UploaderConfig } from "./utils/s3-uploader";
